import * as actions from 'actions/seoMetadataActions';
import { PAGE_DATA_ACTIONS } from 'actions/pageActionsV4';
import { AsyncStatus } from 'utils/asyncStatusHelper';
import get from 'lodash/get';
const { seoMetadataActions } = actions;
const initialState = {
    isFetching: false,
    metadata: {
        title: 'Online Shopping India Mobile, Cameras, Lifestyle &amp; more Online @ Flipkart.com'
    },
    asyncStatus: AsyncStatus.INIT
};
export default function seoMetaData(state = initialState, action) {
    switch (action.type) {
        case seoMetadataActions.GET_SEO_DATA_REQUEST:
            return Object.assign({}, state, { asyncStatus: AsyncStatus.LOADING });
        case PAGE_DATA_ACTIONS.SUCCESS:
            const pageNumber = get(action, 'requestContext.pageContext.pageNumber');
            if (action.data && (!pageNumber || pageNumber <= 1 || __SERVER__)) {
                const metadata = get(action, 'data.pageData.seoData');
                return Object.assign({}, state, { asyncStatus: AsyncStatus.SUCCESS }, { metadata });
            }
            return state;
        case seoMetadataActions.GET_SEO_DATA_SUCCESS:
            if (action.data) {
                const metadata = action.data;
                return Object.assign({}, state, { asyncStatus: AsyncStatus.SUCCESS }, { metadata });
            }
            return state;
        case seoMetadataActions.RESET_SEO_METADATA:
            return Object.assign({}, initialState);
        case seoMetadataActions.RENDER_SEO_PRICELIST:
            return Object.assign({}, state, {
                answerBox: action.data
            });
        default:
            return state;
    }
}
